import { render, staticRenderFns } from "./AbsenceLeave.vue?vue&type=template&id=68bf0276&scoped=true"
import script from "./AbsenceLeave.vue?vue&type=script&lang=js"
export * from "./AbsenceLeave.vue?vue&type=script&lang=js"
import style0 from "./AbsenceLeave.vue?vue&type=style&index=0&id=68bf0276&prod&lang=css"
import style1 from "./AbsenceLeave.vue?vue&type=style&index=1&id=68bf0276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf0276",
  null
  
)

export default component.exports